<template>
  <b-card class="mb-2">
    <h5 class="mb-2">Procedimientos</h5>

    <!-- BUSCADOR + CANTIDAD + AGREGAR EN UNA FILA -->
    <b-row class="align-items-end">
      <b-col md="7">
        <b-form-group label="Procedimiento">
          <v-select
            :options="opciones"
            :reduce="o => o"
            label="label"
            :filterable="true"
            :clearable="true"
            :searchable="true"
            placeholder="Buscar procedimiento…"
            v-model="seleccion"
            @search="onSearch"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group label="Cantidad" class="mb-0">
          <b-form-input type="number" min="1" step="1" v-model.number="form.cantidad" />
        </b-form-group>
      </b-col>
      <b-col md="2" class="d-flex align-items-end">
        <b-button variant="primary" block :disabled="!seleccion || !form.cantidad || form.cantidad < 1" @click="agregar">
          + Agregar
        </b-button>
      </b-col>
    </b-row>

    <!-- LISTA / VACÍO -->
    <b-alert v-if="!itemsLocal.length" variant="danger" class="mt-2" show>
      <i class="fa-solid fa-triangle-exclamation mr-1"></i>
      No ha registrado ningún procedimiento
    </b-alert>

    <b-table
      v-else
      :items="itemsLocal"
      :fields="fields"
      small
      responsive
      class="mt-2"
    >
      <template #cell(acciones)="{ index }">
        <b-button size="sm" variant="danger" @click="eliminar(index)">
          <i class="fa fa-times"></i>
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'PaqProcedimiento',
  components: { vSelect },
  props: {
    // lista final a sincronizar con el padre (servicios.procedimientos)
    items: { type: Array, default: () => [] },
    // función de búsqueda opcional: (q)=>Promise<Array>
    // Para tu caso usaremos procedimientosService.searchSns desde el padre
    buscar: { type: Function, default: null },
  },
  data () {
    return {
      seleccion: null,
      opciones: [],
      itemsLocal: [...this.items],
      form: { cantidad: 1 },
      fields: [
        { key: 'codigo', label: 'Código', thClass: 'text-center', tdClass: 'align-middle' },
        { key: 'descripcion', label: 'Descripción', thClass: 'text-center', tdClass: 'align-middle' },
        { key: 'cantidad', label: 'Cant.', thClass: 'text-center', tdClass: 'text-center align-middle', sortable: true },
        { key: 'acciones', label: 'Acciones', thClass: 'text-center', tdClass: 'text-right align-middle' },
      ],
    }
  },
  watch: {
    itemsLocal: {
      deep: true,
      handler (val) { this.$emit('update:items', val) }
    }
  },
  methods: {
    async onSearch (q) {
      if (!q || q.trim().length < 3) { this.opciones = []; return }

      if (!this.buscar) {
        // demo sin backend
        this.opciones = Array.from({ length: 6 }).map((_, i) => ({
          codigo: `${1000 + i}`,
          descripcion: `${q.toUpperCase()} PROC ${i + 1}`,
          label: `(${1000 + i}) ${q.toUpperCase()} PROC ${i + 1}`,
        }))
        return
      }

      const rs = await this.buscar(q)
      this.opciones = (rs || []).map(x => {
        const codigo = x.codigo ?? x.code ?? x.value ?? x.id
        const descripcion = x.descripcion ?? x.text ?? x.nombre
        return { codigo, descripcion, label: `(${codigo}) ${descripcion}` }
      })
    },
    agregar () {
      if (!this.seleccion) return
      const payload = {
        codigo: this.seleccion.codigo,
        descripcion: this.seleccion.descripcion,
        cantidad: this.form.cantidad || 1,
        label: this.seleccion.label,
      }
      this.itemsLocal = [...this.itemsLocal, payload]
      this.seleccion = null
      this.form.cantidad = 1
    },
    eliminar (idx) { this.itemsLocal.splice(idx, 1) },
  }
}
</script>
